export class CrossGoniometerConfig {
}
CrossGoniometerConfig.A_color = 0xFF4DDD;
CrossGoniometerConfig.B_color = 0xFF4DDD;
CrossGoniometerConfig.C_color = 0xFF4DDD;
CrossGoniometerConfig.D_color = 0xFF4DDD;
CrossGoniometerConfig.center_color = 0xFF4DDD;
CrossGoniometerConfig.ACLine_color = 0xFF4DDD;
CrossGoniometerConfig.BDLine_color = 0xFF4DDD;
CrossGoniometerConfig.lengthACLabel_backgroundColor = "rgba(236, 68, 204, 0.6)";
CrossGoniometerConfig.lengthACLabel_fontColor = "#ffffff";
CrossGoniometerConfig.lengthBDLabel_backgroundColor = "rgba(236, 68, 204, 0.6)";
CrossGoniometerConfig.lengthBDLabel_fontColor = "#ffffff";
CrossGoniometerConfig.angleACLabel_backgroundColor = "rgba(236, 68, 204, 0.6)";
CrossGoniometerConfig.angleACLabel_fontColor = "#ffffff";
CrossGoniometerConfig.angleBDLabel_backgroundColor = "rgba(236, 68, 204, 0.6)";
CrossGoniometerConfig.angleBDLabel_fontColor = "#ffffff";
//# sourceMappingURL=CrossGoniometerConfig.js.map